import React from "react";
import css from './floor.module.scss'
import classNames from "classnames";
import {observer} from "mobx-react";
import GoodsType, {goodsTypeEnumMap} from "enum/GoodsType";
import showPrice from "../../utils/ShowPrice";
import MyRouterUtil from "../../utils/MyRouterUtil";
import {useHistory} from "react-router-dom";

const Index = ({className, data}) => {
    let {floor, adv1, adv2, goodsList = []} = data
    const {id, pgoodscategoryId, name, order} = floor

    const history = useHistory()

    goodsList = goodsList.map(item => {
        const {pddGoodsSign, jdItemId, selfGoodsId} = item;

        let id;
        switch (item.goodsType) {
            case GoodsType.PDD:
                id = pddGoodsSign;
                break;
            case GoodsType.JD:
                id = jdItemId
                break;
            case GoodsType.SELF:
            default:
                id = selfGoodsId
                break;
        }
        return {
            ...item,
            id
        }
    })

    const specialGoods = goodsList[0]
    goodsList = goodsList.filter(item => item.id !== specialGoods.id)

    const goodsList1 = goodsList.slice(0, 2)
    const goodsList2 = goodsList.slice(2, 6)

    // 商品详情
    const toGoodsInfo = ({goodsType, id}) => {
        MyRouterUtil.build({history}).toGoodsInfo({goodsType, id})
    }

    const toAdv1 = () => {
        window.open(adv1.link, '_blank')
    }

    const toAdv2 = () => {
        window.open(adv2.link, '_blank')
    }

    return (
        <div id={`floor-${id}`} className={classNames(className, css.root)}>
            <div className={css.container}>
                <div className={css.title}>
                    {name}
                </div>

                <div className={css.floor1}>
                    <div className={css.adv1} onClick={toAdv1}>
                        <img src={adv1.file} alt=""/>
                    </div>
                    <div className={css.goodsListContainer}>
                        <div className={css.goodsList}>
                            {
                                goodsList1.map(item => {
                                    const {id, mainPic, name, price, oldPrice, goodsType} = item;
                                    return (
                                        <div
                                            key={id} className={css.goods}
                                            onClick={() => toGoodsInfo({goodsType, id})}
                                        >

                                            <div className={css.top}>
                                                <img src={mainPic} alt=""/>
                                            </div>
                                            <div className={css.bottom}>
                                                <div className={css.nameWrapper}>
                                                    <div className={css.name}>
                                                        <span className={classNames({
                                                            [css.pdd]: goodsType === GoodsType.PDD,
                                                            [css.jd]: goodsType === GoodsType.JD,
                                                            [css.self]: goodsType === GoodsType.SELF,
                                                        })}>
                                                            {goodsTypeEnumMap.get(goodsType)}
                                                        </span>
                                                        {name}
                                                    </div>
                                                </div>
                                                <div className={css.priceWrapper}>
                                                    <div className={css.price}>
                                                        {/*{showPrice(price)}*/}
                                                        {price}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>

                <div className={css.floor2}>
                    <div className={css.left}>
                        {/* 特殊商品 */}
                        <div
                            className={css.specialGoods}
                            onClick={() => toGoodsInfo({goodsType: specialGoods?.goodsType, id: specialGoods?.id})}
                        >
                            <div className={css.top}>
                                <div className={css.imgWrapper}>
                                    <img src={specialGoods?.mainPic} alt=""/>
                                </div>
                            </div>
                            <div className={css.bottom}>
                                <div className={css.nameWrapper}>
                                    <div className={css.name}>
                                        {specialGoods?.name}
                                    </div>
                                </div>
                                <div className={css.priceWrapper}>
                                    <div className={css.price}>
                                        {specialGoods && `￥${specialGoods?.price}`}
                                    </div>
                                    <div className={css.oldPrice}>
                                        {specialGoods && `￥${specialGoods?.oldPrice}`}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* 商品列表 */}
                        <div className={css.goodsList}>
                            {
                                goodsList2.map(item => {
                                    const {id, mainPic, name, price, oldPrice, goodsType} = item;
                                    return (
                                        <div
                                            key={id}
                                            className={css.goods}
                                            onClick={() => toGoodsInfo({goodsType, id})}
                                        >
                                            <div className={css.left}>
                                                <div className={css.imgWrapper}>
                                                    <img src={mainPic} alt=""/>
                                                </div>
                                            </div>
                                            <div className={css.right}>
                                                <div className={css.name}>
                                                    <span className={classNames({
                                                        [css.self]: goodsType === GoodsType.SELF,
                                                        [css.pdd]: goodsType === GoodsType.PDD,
                                                        [css.jd]: goodsType === GoodsType.JD
                                                    })}>{goodsTypeEnumMap.get(goodsType)}</span>
                                                    {name}
                                                </div>
                                                <div className={css.price}>
                                                    {`￥${price}`}
                                                </div>
                                                <div className={css.oldPrice}>
                                                    {`￥${oldPrice}`}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className={css.right} onClick={toAdv2}>
                        <img src={adv2.file} alt=""/>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default observer(Index)
